/**
 * Use this file for JavaScript code that you want to run in the front-end
 * on posts/pages that contain this block.
 *
 * When this file is defined as the value of the `viewScript` property
 * in `block.json` it will be enqueued on the front end of the site.
 *
 * Example:
 *
 * ```js
 * {
 *   "viewScript": "file:./view.js"
 * }
 * ```
 *
 * If you're not making any changes to this file because your project doesn't need any
 * JavaScript running in the front-end, then you should delete this file and remove
 * the `viewScript` property from `block.json`.
 *
 * @see https://developer.wordpress.org/block-editor/reference-guides/block-api/block-metadata/#view-script
 */

document.addEventListener('DOMContentLoaded', () => {
	document.querySelectorAll('.osm-map-placeholder').forEach((wrapper) => {
	  const lat = parseFloat(wrapper.dataset.lat);
	  const lng = parseFloat(wrapper.dataset.lng);
	  const zoom = parseInt(wrapper.dataset.zoom, 10);
	  const mapContainer = wrapper.querySelector('.osm-map');
	  const overlay = wrapper.querySelector('.osm-overlay');
  
	  const hasConsent = localStorage.getItem('silktideCookieChoice_osm') === 'true';
  
	  function loadLeaflet(callback) {
		if (typeof L !== 'undefined') {
		  callback();
		  return;
		}
  
		const leafletCss = document.createElement('link');
		leafletCss.rel = 'stylesheet';
		leafletCss.href = 'https://unpkg.com/leaflet@1.9.4/dist/leaflet.css';
		document.head.appendChild(leafletCss);
  
		const leafletScript = document.createElement('script');
		leafletScript.src = 'https://unpkg.com/leaflet@1.9.4/dist/leaflet.js';
		leafletScript.onload = callback;
		document.body.appendChild(leafletScript);
	  }
  
	  function renderMap() {
		if (overlay) overlay.remove();
  
		const map = L.map(mapContainer, {scrollWheelZoom: true}).setView([lat, lng], zoom);
		L.tileLayer('https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png', {
		  maxZoom: 19,
		  attribution: '&copy; OpenStreetMap-Mitwirkende',
		}).addTo(map);

        if (wrapper.dataset.marker === 'true') {
            const marker = L.marker([lat, lng]).addTo(map);
            if (wrapper.dataset.markerTitle) {
              marker.bindPopup(wrapper.dataset.markerTitle).openPopup();
            }
        }
          
	  }
  
	  function activateConsent() {
		// Setzt den OSM-Cookie auf true
		localStorage.setItem('silktideCookieChoice_osm', 'true');
  
		// Optional: Callback manuell ausführen, falls CMP dynamisch reagiert
		if (
		  typeof silktideCookieBannerManager !== 'undefined' &&
		  typeof silktideCookieBannerManager.runStoredCookiePreferenceCallbacks === 'function'
		) {
		  silktideCookieBannerManager.runStoredCookiePreferenceCallbacks();
		}
	  }
  
	  if (hasConsent) {
		loadLeaflet(renderMap);
	  } else {
		// Benutzer muss Button klicken
		const button = wrapper.querySelector('.osm-load-map');
		button?.addEventListener('click', () => {
		  activateConsent(); // Setzt Zustimmung aktiv
		  loadLeaflet(renderMap);
		});
	  }
	});
  });